import React from 'react';
import { connect } from 'react-redux';
import './CourseEvaluate.less';
import Picture from '../../../../components/picture/Picture';
import { getVal } from '../../../../lib/utils/UtilsCommon';
import { formatDate } from '../../../../lib/utils/UtilsFormatter';
import EmptyContent from '../empty-content/EmptyContent';

/**
 * 可选参数
 */
interface IProps {
	data: any;
	evaluationList?: any;
}

/**
 * CourseEvaluate
 */
class CourseEvaluate extends React.PureComponent<IProps> {
	public evalTextMap: string[] = ['暂无评分', '大失所望', '比较一般', '还算不错', '非常满意', '物超所值'];

	/**
	 * 获取评价
	 * @param score 分数
	 */
	public scoreText(score: number): string {
		let idx: number = 0;
		if (typeof score === 'number') {
			if (score > 5) {
				idx = 5;
			} else if (score > 1) {
				idx = Math.round(score);
			} else {
				idx = 1;
			}
		}

		return this.evalTextMap[idx];
	}

	/**
	 * render
	 */
	public render(): any {
		return (
			<ul className="p-course-evaluate">
				{this.props.evaluationList.length > 0 ? (
					this.props.evaluationList.map((item: any, idx: number): any => (
						<li key={idx}>
							<div className="evaluate-user">
								<Picture placeholder src={item.headImageUrl} className="user-poster" />
								<p>{item.userName}</p>
								<span className="evaluate-time">{formatDate(item.evalTime, 'yyyy.MM.dd')}</span>
							</div>
							<div className="evaluate-score">
								<span>{this.scoreText(item.score)}</span>
							</div>
							<div className="evaluate-content">{item.content}</div>
							{item.topicName && (
								<div className="evaluate-attr">
									<span>{item.topicName}</span>
								</div>
							)}
						</li>
					))
				) : (
					<EmptyContent />
				)}
			</ul>
		);
	}
}

/**
 * mapStateToProps
 */
function mapStateToProps(state: any): any {
	return {
		evaluationList: getVal(state, 'evaluation.evaluations', []),
	};
}

export default connect(mapStateToProps, {})(CourseEvaluate);
